// Per-formula written area ("footprint"), persisted in the workbook's
// document settings so the writer can clear old results after a reload.
// The settings object is injected (Office.context.document.settings in the
// add-in, a fake in tests); this module never references the global Office.

export interface Footprint { sheet: string; row: number; col: number; rows: number; cols: number }

export interface FootprintStore {
  get(key: string): Footprint | undefined; // key = `${sheetName}!${formulaAddress}`
  set(key: string, fp: Footprint | undefined): void;
  all(): [string, Footprint][];
  save(): Promise<void>;
}

export interface SettingsLike {
  get(k: string): any;
  set(k: string, v: any): void;
  saveAsync(cb: (r: any) => void): void;
}

const SETTINGS_KEY = "eav.footprints";

function load(settings: SettingsLike): Record<string, Footprint> {
  const raw = settings.get(SETTINGS_KEY);
  if (raw && typeof raw === "object" && !Array.isArray(raw)) return { ...raw };
  return {};
}

export function settingsStore(settings: SettingsLike): FootprintStore {
  const map = new Map<string, Footprint>(Object.entries(load(settings)));
  return {
    get: (key) => map.get(key),
    set(key, fp) {
      if (fp === undefined) map.delete(key);
      else map.set(key, fp);
      const obj: Record<string, Footprint> = {};
      map.forEach((v, k) => { obj[k] = v; });
      settings.set(SETTINGS_KEY, obj);
    },
    all: () => [...map.entries()],
    save: () =>
      new Promise<void>((resolve, reject) => {
        settings.saveAsync((r) => {
          if (r && r.status === "failed") reject(new Error(r.error?.message ?? "settings save failed"));
          else resolve();
        });
      }),
  };
}
